export default __webpack_public_path__ + "static/media/IBMPlexSans-Regular.1525928a.ttf";